import {
  deepPurple,
  blue,
  red,
  orange,
  green,
  yellow,
  brown,
  grey,
} from '@mui/material/colors';

type Color = keyof typeof deepPurple;

const availableColorGroups = [
  deepPurple,
  blue,
  red,
  orange,
  green,
  yellow,
  brown,
  grey,
];

const availableColors = availableColorGroups.reduce(
  (acc: string[], colorGroup: Record<Color, string>) => [
    ...acc,
    ...Object.values(colorGroup),
  ],
  [],
);

export function calculateAvatarColor(initials: string): string {
  if (!initials) {
    return deepPurple[50];
  }

  let hash = initials.charCodeAt(0);

  if (initials.length > 1) {
    hash = hash * 1000 + initials.charCodeAt(1);
  }

  const finalIndex = hash % availableColors.length;

  return availableColors[finalIndex];
}
